import styled from "styled-components";
import { COLORS } from "../../styles";

export const SignPageContainer = styled.div`
	background: ${COLORS.White};
	display: grid;
	height: 100%;
`;
